module.exports = __webpack_public_path__ + "0314c52089cd829cbb65f5b8a8167e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/0.25ct.png
// module id = 796
// module chunks = 0